import React from 'react';
import PropTypes from 'prop-types';
import {capitalize} from 'lodash';
import {Button, Dialogue, TextField, Modal, addToast} from '@albert-io/atomic';
import {TemplateModelV1} from 'resources/GeneratedModels/Template/TemplateModel.v1';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import {resource} from '@albert-io/json-api-framework/request/builder';

class RenameFolderModal extends React.Component {
  static propTypes = {
    folder: PropTypes.instanceOf(TemplateModelV1),
    handleClose: PropTypes.func,
    onSaveSuccess: PropTypes.func,
    isAssignment: PropTypes.bool
  };

  static defaultProps = {
    onSaveSuccess: () => {},
    isAssignment: false
  };

  constructor(props) {
    super(props);
    this.state = {
      newFolderName: props.folder.getName(),
      hasError: false,
      errorMessage: ''
    };
  }

  folderNameInputHandler = (e) => {
    this.setState({
      newFolderName: e.target.value
    });
  };

  resetErrorMessage = () => {
    this.setState({
      hasError: false,
      errorMessage: ''
    });
  };

  getItemName = () => {
    return this.props.isAssignment ? 'assignment' : 'folder';
  };

  /**
   * Creates a new folder and invalidates the resource to force auto update
   */
  handleFolderRename = () => {
    const {folder} = this.props;
    const {newFolderName} = this.state;
    if (!newFolderName.trim()) {
      this.setState({
        hasError: true,
        errorMessage: `${capitalize(this.getItemName())} cannot be blank`
      });
      return;
    }

    if (newFolderName.length > 256) {
      this.setState({
        hasError: true,
        errorMessage: `${capitalize(this.getItemName())} name must be 256 characters or less.`
      });
      return;
    }

    folder
      .setName(newFolderName)
      .save()
      .then(() => {
        addToast({
          message: `Your ${this.getItemName()} was renamed`,
          title: 'Success!',
          type: 'success'
        });
        invalidatePartialInterest(
          resource('templates_v1').mandarkEndpoint(['templates_v1']).done()
        );
        this.props.onSaveSuccess();
      })
      .catch(() => {
        addToast({
          message: `Something went wrong and your ${this.getItemName()} was not renamed`,
          title: 'Error:',
          type: 'danger'
        });
      });
    this.props.handleClose();
  };

  render() {
    return (
      <Modal
        ariaLabel={`Rename ${capitalize(this.getItemName())} Modal`}
        handleClose={this.props.handleClose}
      >
        {({CloseButtonWrapper, modalContentStyle}) => {
          return (
            <Dialogue
              inModal
              hideCloseBtn
              size='m'
              handleClose={this.props.handleClose}
              className={modalContentStyle}
            >
              <Dialogue.Body>
                <TextField
                  border
                  label='Enter a new name:'
                  error={this.state.hasError}
                  message={this.state.errorMessage}
                  onChange={this.folderNameInputHandler}
                  onFocus={this.resetErrorMessage}
                  defaultValue={this.props.folder.getName()}
                />
              </Dialogue.Body>
              <Dialogue.BtnGroup>
                <CloseButtonWrapper flex>
                  <Button variant='text'>Cancel</Button>
                </CloseButtonWrapper>
                <Button onClick={this.handleFolderRename}>Rename</Button>
              </Dialogue.BtnGroup>
            </Dialogue>
          );
        }}
      </Modal>
    );
  }
}

export default RenameFolderModal;
